"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyAppContext = void 0;
const react_1 = require("react");
exports.JourneyAppContext = react_1.createContext({});
exports.JourneyAppContext.displayName = 'JourneyAppContext';
